__turbopack_context__.v({
  "chip": "Chip-module-scss-module__FCAk4W__chip",
  "content": "Chip-module-scss-module__FCAk4W__content",
  "labelText": "Chip-module-scss-module__FCAk4W__labelText",
  "linked": "Chip-module-scss-module__FCAk4W__linked",
});
